import ActionsForm from '@/shared/mixins/actionsForm'
import FoldersCard from '@/views/private/realestate/commissions/components/FoldersCard/FoldersCard.vue'
import TableCommissions from '@/views/private/realestate/commissions/components/TableCommissions/TableCommissions.vue'
import CommissionDetailsAdm from '@/views/private/realestate/commissions/components/CommissionDetailsAdm/CommissionDetailsAdm.vue'
import SalesinformationAdm from '@/views/private/realestate/commissions/components/salesinformationAdm/salesinformationAdm.vue'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import Roles from '@/shared/utils/roles'
import PermisionMixin from '@/store/module/permission/mixin'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'Commissions',
  mixins: [ActionsForm, PermisionMixin],
  components: {
    FoldersCard,
    SalesinformationAdm,
    TableCommissions,
    CommissionDetailsAdm
  },
  data () {
    return {
      flDetails: false,
      tablereload: 0,
      roles: Roles,
      selectedComissao: {}
    }
  },
  methods: {
    edit (obj) {
      this.selectedComissao = obj
      this.flDetails = true
    },
    deleteCommission (id) {
      CommissionRepository.DeleteComissao(id)
        .then(Response => {
          this.consultacomissao = Response.data.data
          this.tablereload++
          this.$refs.tableCommission.Delete(Response)
        })
        .catch(() => {})
    },
    GetFilter (filter, isFilter) {
      if (localStoreHelper.consulta.comissao() != null) {
        isFilter = true
      }
      this.$refs.tableCommission.searchWithFilter(filter, isFilter)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissions/commissions.js